import * as c from '../constants/actionTypes';

let initialState = [{
  open_question : false,
  index: ''
  }];

let opened = {
  array: [],
  index: ''
};

export default (state = opened, action) => {
  switch (action.type) {
    case c.TOGGLE_QUESTION:
      var index = action.array.indexOf(action.index);
      if (index > -1) {
          action.array.splice(index, 1);
      }else{
        action.array.push(action.index)
      }
      var newState ={};
      newState.array = action.array;
      return state = Object.assign({}, state, newState);
    case c.CLOSE_QUESTION:
      var newState = state;
      newState.extras_modal = action.state;
      return state = Object.assign({}, state, newState);
    default:
      return opened;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/FAQ.js